import type { EnMessages } from "./en"

export const es: EnMessages = {
  nav: {
    dashboard: "Panel",
    companies: "Empresas",
    jobCodes: "Códigos de trabajo",
    jobSites: "Obras",
    employees: "Empleados",
    timeClock: "Reloj",
    adminMode: "Modo administrativo",
  },
  common: {
    add: "Agregar",
    edit: "Editar",
    delete: "Eliminar",
    cancel: "Cancelar",
    save: "Guardar",
    saving: "Guardando…",
    close: "Cerrar",
    actions: "Acciones",
    confirm: "Confirmar",
    deleting: "Eliminando…",
  },
  companies: {
    title: "Empresas",
    subtitle: "Empresas de construcción",
    add: "Agregar empresa",
    adding: "Agregando…",
    cancel: "Cancelar",
    changeCompany: "Cambiar empresa",
    empty: "Aún no hay empresas.",
    columnCompany: "Empresa",
    columnCode: "Código",
    modalTitle: "Agregar empresa",
    modalHelper: "Nombre de la empresa y un código corto. Luego puede agregar obras.",
    nameLabel: "Nombre de la empresa",
    codeLabel: "Código de la empresa",
    codeHelper: "Se muestra en las obras y el tiempo. Letras y números.",
    nameRequired: "Ingrese el nombre de la empresa.",
    codeRequired: "Ingrese un código de empresa.",
    codeDuplicate: "Ese código ya está en uso.",
    submitFailed: "No se pudo agregar la empresa. Inténtelo de nuevo.",
    loadFailed: "No se pudieron cargar las empresas. Inténtelo de nuevo.",
  },
  jobCodes: {
    title: "Códigos de trabajo",
    empty: "Aún no hay códigos de trabajo.",
    loadFailed: "No se pudieron cargar los códigos de trabajo. Inténtelo de nuevo.",
    columnCode: "Código",
    columnName: "Nombre",
    columnJobSite: "Obra",
    add: "Agregar código de trabajo",
    modalAddTitle: "Agregar código de trabajo",
    modalEditTitle: "Editar código de trabajo",
    codeLabel: "Código de trabajo",
    codeHelper: "Código de costo de Sage. Un número con hasta 3 decimales, por ejemplo 2120 o 2120.5.",
    nameLabel: "Nombre",
    jobSiteLabel: "Obra",
    codeRequired: "Ingrese un código de trabajo.",
    codeInvalid: "Ingrese un número con hasta 3 decimales, por ejemplo 2120 o 2120.5.",
    nameRequired: "Ingrese un nombre.",
    jobSiteRequired: "Elija una obra.",
    deleteTitle: "Eliminar código de trabajo",
    deleteConfirm: "¿Eliminar este código de trabajo? Esta acción no se puede deshacer.",
    drop: "Suelte códigos de trabajo aquí, o elija un archivo",
    dropHelper: "Libro de Sage o una lista de códigos. Se agregan a esta obra.",
    importing: "Agregando códigos de trabajo…",
    importAdded: "Se agregaron {count} códigos de trabajo.",
    importFailedRows: "No se pudieron agregar estas filas:",
    importRowFailed: "Fila {row}: {detail}",
    importInvalidFile: "Suelte un libro de Sage o una lista de códigos de trabajo.",
    importEmpty: "Esa lista no tenía códigos de trabajo.",
    importFailed: "No se pudieron agregar esos códigos de trabajo. Inténtelo de nuevo.",
  },
  jobSites: {
    title: "Obras",
    empty: "Aún no hay obras.",
    loadFailed: "No se pudieron cargar las obras. Inténtelo de nuevo.",
    columnName: "Obra",
    columnCode: "Número",
    columnAddress: "Dirección",
    columnSupervisor: "Supervisor",
    add: "Agregar obra",
    modalAddTitle: "Agregar obra",
    modalEditTitle: "Editar obra",
    jobNumberLabel: "Número de obra",
    jobNumberHelper: "Número de trabajo de Sage. Un número entero mayor que 0.",
    nameLabel: "Nombre",
    addressLabel: "Dirección",
    cityLabel: "Ciudad",
    stateLabel: "Estado",
    zipLabel: "Código postal",
    supervisorLabel: "Supervisor",
    jobNumberRequired: "Ingrese un número de obra.",
    jobNumberInvalid: "Ingrese un número entero mayor que 0.",
    nameRequired: "Ingrese un nombre.",
    deleteTitle: "Eliminar obra",
    deleteConfirm: "¿Eliminar esta obra? Esta acción no se puede deshacer.",
    view: "Ver",
  },
  employees: {
    title: "Empleados",
    empty: "Aún no hay empleados.",
    loadFailed: "No se pudieron cargar los empleados. Inténtelo de nuevo.",
    columnName: "Nombre",
    columnNumber: "Número",
    columnRole: "Puesto",
    add: "Agregar empleado",
    modalAddTitle: "Agregar empleado",
    modalEditTitle: "Editar empleado",
    employeeNumLabel: "Número de empleado",
    employeeNumHelper: "Número de empleado de Sage. Un número entero mayor que 0.",
    firstNameLabel: "Nombre",
    lastNameLabel: "Apellido",
    employeeNumRequired: "Ingrese un número de empleado.",
    employeeNumInvalid: "Ingrese un número entero mayor que 0.",
    firstNameRequired: "Ingrese un nombre.",
    lastNameRequired: "Ingrese un apellido.",
    deleteTitle: "Eliminar empleado",
    deleteConfirm: "¿Eliminar este empleado? Esta acción no se puede deshacer.",
  },
  company: {
    missing: "Esta página necesita una empresa seleccionada.",
  },
  import: {
    drop: "Suelte un libro de Sage aquí, o elija un archivo",
    helper: "Libro de Excel de Sage. Las columnas adicionales se ignoran.",
    sourceEmployees: "De Sage PR 5-2-1 Employees (o una lista de Field Frontline con el mismo formato).",
    sourceJobCodes: "De Sage PJ 6-2 Budgets (o la plantilla de presupuesto Accurate Metal).",
    sourceJobSites: "Se crean a partir de los números de trabajo distintos en las cargas de Sage PJ 6-2 Budgets y PJ 6-3 Job Costs.",
    reading: "Leyendo el libro",
    added: "Se agregaron {count} {noun} desde el libro.",
    missingColumns: "Ese libro no tiene las columnas de Sage que esta página necesita.",
    invalidType: "Elija un libro de Excel.",
    failed: "No se pudo importar ese libro. Inténtelo de nuevo.",
    nounJobSites: "obras",
    nounJobCodes: "códigos de trabajo",
    nounEmployees: "empleados",
  },
  adminMode: {
    title: "Modo administrativo",
    subtitle: "El personal de oficina marca entrada en la app con estas tareas.",
    tasksTitle: "Tareas administrativas",
    tasksHelper: "El personal elige una de estas, o Personalizada, al marcar entrada. Puede cambiar de tarea durante el día.",
    addTask: "Agregar tarea",
    editTask: "Editar tarea",
    nameEnLabel: "Nombre de la tarea (inglés)",
    nameEsLabel: "Nombre de la tarea (español)",
    payrollCodeLabel: "Código de costo de Sage",
    payrollCodeHelper: "Obligatorio. Un número como 9010. El tiempo administrativo en esta tarea se exporta a la nómina diaria 5-5-1 con este código.",
    payrollCodeRequired: "Ingrese el código de costo de Sage como número, por ejemplo 9010.",
    sortOrderLabel: "Orden",
    nameRequired: "Escriba un nombre de tarea.",
    columnTask: "Tarea",
    columnSpanish: "Español",
    columnPayrollCode: "Código Sage",
    columnStatus: "Estado",
    active: "Activa",
    inactive: "Inactiva",
    deactivate: "Desactivar",
    reactivate: "Reactivar",
    tasksEmpty: "Aún no hay tareas administrativas.",
    staffTitle: "Personal en modo administrativo",
    staffHelper: "Active el modo administrativo para personal de oficina o de campo y vincule su cuenta de la app. El interruptor Admin de la app solo funciona para los empleados activados aquí.",
    columnAdminMode: "Modo administrativo activado",
    adminModeOn: "Sí",
    adminModeOff: "No",
    needsLogin: "Vincule una cuenta para que lo pueda usar.",
    columnEmployee: "Empleado",
    columnLogin: "Cuenta de la app",
    notLinked: "Sin vincular",
    staffEmpty: "Aún no hay empleados.",
    timeSheetTitle: "Hoja de horas administrativa",
    columnDate: "Fecha",
    columnClockIn: "Entrada",
    columnClockOut: "Salida",
    columnTasks: "Tareas",
    columnHours: "Horas",
    columnLocation: "Ubicación al entrar",
    columnPunches: "Salida / cambios de tarea",
    stillClockedIn: "En turno",
    autoEnded: "Salida automática",
    custom: "Personalizada",
    timeSheetEmpty: "No hay tiempo administrativo en este rango de fechas.",
    loadFailed: "No se pudo cargar el modo administrativo. Intente de nuevo.",
    saveFailed: "No se pudo guardar. Intente de nuevo.",
  },
  timeClock: {
    title: "Reloj",
    subtitle: "Alertas de oficina, registros lejanos y ajustes del reloj.",
    alertsTitle: "Alertas de oficina",
    alertsHelper: "Entradas bloqueadas porque la ubicación del teléfono estaba apagada. Permitir deja que la próxima entrada de ese empleado hoy pase sin ubicación, una sola vez.",
    alertsEmpty: "No hay alertas abiertas.",
    showClosed: "Mostrar cerradas",
    columnEmployee: "Empleado",
    columnDate: "Fecha",
    columnMode: "Modo",
    columnJobSite: "Obra",
    columnAttempts: "Intentos",
    columnLastAttempt: "Último intento",
    columnStatus: "Estado",
    modeAdmin: "Administrativo",
    modeForeman: "Cuadrilla",
    statusOpen: "Bloqueada",
    statusAllowed: "Permitida por {name} a las {at}",
    statusUsed: "Permitida por {name} a las {at} · usada",
    statusDismissed: "Descartada por {name} a las {at}",
    allow: "Permitir entrada",
    dismiss: "Descartar",
    overrideTitle: "Permitir una entrada sin ubicación",
    overrideNoteLabel: "Nota (opcional)",
    overrideHelper: "{name} puede registrar entrada una vez hoy sin ubicación. Se guardan su nombre y la hora.",
    flaggedTitle: "Registros marcados",
    flaggedHelper: "Registros más lejos que la distancia de abajo desde la obra (o la oficina si la obra no tiene coordenadas). Nunca se bloquean; revíselos aquí.",
    flaggedEmpty: "No hay registros marcados en estas fechas.",
    showReviewed: "Mostrar revisados",
    columnPunch: "Registro",
    columnTime: "Hora",
    columnDistance: "Distancia",
    columnLocation: "Ubicación",
    columnReview: "Revisión",
    markReviewed: "Marcar revisado",
    reviewedBy: "Revisado por {name} a las {at}",
    kindClockIn: "Entrada",
    kindClockOut: "Salida",
    kindTaskChange: "Cambio de tarea / obra",
    distanceFrom: "{miles} mi de la {reference}",
    referenceJobSite: "obra",
    referenceOffice: "oficina",
    farFlag: "Lejos",
    settingsTitle: "Ajustes del reloj",
    settingsHelper: "La dirección y coordenadas de la oficina se usan para el modo administrativo y para obras sin coordenadas.",
    addressLabel: "Dirección de la oficina",
    cityLabel: "Ciudad",
    stateLabel: "Estado",
    zipLabel: "Código postal",
    latitudeLabel: "Latitud de la oficina",
    longitudeLabel: "Longitud de la oficina",
    thresholdLabel: "Distancia lejana (millas)",
    thresholdHelper: "Los registros más lejos que esto se marcan para revisión. Predeterminado 0.5.",
    customCodeLabel: "Código de costo Sage para tareas personalizadas",
    customCodeHelper: "El tiempo administrativo con tarea escrita (Personalizada) se exporta con este código.",
    adminJobLabel: "Número de obra Sage para tiempo administrativo",
    adminJobHelper: "Opcional. El tiempo administrativo se exporta con este número de obra; en blanco lo deja vacío.",
    saveSettings: "Guardar ajustes",
    saved: "Guardado.",
    numberRequired: "{field} debe ser un número.",
    coordsPair: "Ingrese latitud y longitud, o deje ambas en blanco.",
    unknownUser: "alguien",
    loadFailed: "No se pudo cargar. Intente de nuevo.",
    saveFailed: "No se pudo guardar. Intente de nuevo.",
  },
  signInLocation: {
    title: "Ubicaciones al entrar",
    withAccuracy: "{coords} (±{meters} m)",
    denied: "Permiso de ubicación denegado",
    unavailable: "Ubicación no disponible",
    timeout: "Se agotó el tiempo de ubicación",
    missing: "No registrada",
    openMap: "Abrir mapa",
    empty: "No hay entradas este día.",
  },
  payroll: {
    title: "Exportación de nómina",
    helper: "Nómina diaria de Sage 100 Contractor (PR 5-5-1 / PRDAILY). Incluye tiempo de cuadrilla y tiempo administrativo (códigos Sage de la tarea, o el código Personalizada de la empresa, con el número de obra administrativo). Revise las filas y luego descargue.",
    companyLabel: "Empresa",
    companyRequired: "Elija una empresa.",
    companiesLoadFailed: "No se pudieron cargar las empresas. Inténtelo de nuevo.",
    fromLabel: "Desde",
    toLabel: "Hasta",
    preview: "Vista previa",
    previewing: "Cargando vista previa…",
    downloadCsv: "Descargar CSV",
    downloadXlsx: "Descargar XLSX",
    downloading: "Descargando…",
    rowCount: "{count} filas de nómina",
    emptyRows: "No hay filas de nómina en este rango de fechas.",
    warningsTitle: "Advertencias",
    warningsHelper: "Sage rechazará estas filas hasta que se corrijan.",
    dateRequired: "Elija una fecha de inicio y una fecha de fin.",
    dateOrder: "La fecha de inicio debe ser anterior o igual a la fecha de fin.",
    loadFailed: "No se pudo cargar la exportación de nómina. Inténtelo de nuevo.",
    downloadFailed: "No se pudo descargar el archivo de nómina. Inténtelo de nuevo.",
    columnPayDate: "Fecha de pago",
    columnEmployee: "Empleado",
    columnJob: "Obra",
    columnCostCode: "Código de trabajo",
    columnHours: "Horas",
    columnDescription: "Descripción",
  },
}
